import service from '../utils/request';

// 获取操作日志列表
export const getOperationLogs = (params) => {
  console.log(params);
  return service.post('/operation-logs/query', params);
};

// 获取操作日志详情
export const getOperationLogDetail = (id) => {
  return service.get(`/operation-logs/${id}`);
};

// 导出操作日志
export const exportOperationLogs = (params) => {
  return service.get('/operation-logs/export', { 
    params,
    responseType: 'blob'
  });
};

